import React from "react";
import styles from "./Loader.module.scss";
import Lottie from "lottie-react";

// Assets
import Loading from "assets/images/lottie/loader.json";

// Icons
import { ieeeLogo } from "helpers/icons";

const Loader = ({ loaded }) => {
  return (
    <div className={`${styles.loader} ${loaded ? styles.loaded : ""}`}>
      <div className={styles.logo}>{ieeeLogo()}</div>
      <div className={styles.loading}>
        <Lottie animationData={Loading} loop={true} style={{ width: 200 }} />
      </div>
    </div>
  );
};

export default Loader;
